import React, { useEffect, useMemo, useState } from "react";

import Sidebar from "../../components/Sidebar";
import Main from "./Package/Main";
import Form from "./Package/Form";

import { getAlert, getDataWithComp, getData } from "../../../utils/SamuiUtils";

const Package = () => {
  const [mode, setMode] = useState("S");
  const [packageList, setPackageList] = useState([]);
  const [packageDetails, setPackageDetails] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialize = async () => {
    try {
      setIsLoading(true);
      setSelectedPackage(null);
      await fetchRealtime();
      setMode("S");
    } catch (error) {
      getAlert("FAILED", error.message || "ไม่สามารถโหลดข้อมูลได้");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchRealtime = async () => {
    const [header, detail, services] = await Promise.all([
      getDataWithComp("Tb_Set_Package_H", "ORDER BY Pack_Id"),
      getData("Tb_Set_Package_D", "1 = 1 ORDER BY Pack_Detail_Id"),
      getDataWithComp("Tb_Set_Service", "ORDER BY Service_Name"),
    ]);

    const arrayBufferToBase64 = (bufferData) => {
      if (!bufferData || !Array.isArray(bufferData)) return null;
      const bytes = Uint8Array.from(bufferData);
      const chunkSize = 0x8000;
      let binary = "";
      for (let i = 0; i < bytes.length; i += chunkSize) {
        const chunk = bytes.subarray(i, i + chunkSize);
        binary += String.fromCharCode.apply(null, chunk);
      }
      return window.btoa(binary);
    };

    const normalizeImageValue = (value) => {
      if (!value) return null;
      if (typeof value === "string") return value;
      if (value?.type === "Buffer" && Array.isArray(value?.data)) {
        return arrayBufferToBase64(value.data);
      }
      return null;
    };

    const normalizedHeader = Array.isArray(header)
      ? header.map((h) => ({ ...h, Pack_Img: normalizeImageValue(h.Pack_Img) }))
      : [];

    setPackageList(normalizedHeader);
    setPackageDetails(Array.isArray(detail) ? detail : []);
    setServiceOptions(Array.isArray(services) ? services : []);
  };

  const serviceCountByPackage = useMemo(() => {
    const counts = {};
    packageDetails.forEach((detail) => {
      const packId = detail?.Pack_Id;
      if (packId == null) return;
      counts[packId] = (counts[packId] || 0) + 1;
    });
    return counts;
  }, [packageDetails]);

  const onPageInsert = () => {
    setSelectedPackage(null);
    setMode("I");
  };

  const onRowSelected = (pack) => {
    if (!pack) {
      getAlert("WARNING", "ไม่พบข้อมูลแพ็คเก็จที่เลือก");
      return;
    }

    const details = packageDetails.filter(
      (detail) => Number(detail?.Pack_Id) === Number(pack.Pack_Id)
    );

    const services = details
      .map((detail) => {
        const service = serviceOptions.find(
          (option) => Number(option?.Service_Id) === Number(detail?.Service_Id)
        );
        if (!service) return null;
        return {
          Service_Id: service.Service_Id,
          Service_Code: service.Service_Code,
          Service_Name: service.Service_Name,
        };
      })
      .filter(Boolean);

    setSelectedPackage({
      Pack_Id: pack.Pack_Id,
      Pack_Name: pack.Pack_Name || "",
      Pack_Img: pack.Pack_Img || "",
      Pack_Price:
        pack.Pack_Price !== undefined && pack.Pack_Price !== null
          ? String(pack.Pack_Price)
          : "",
      Pack_Status: pack.Pack_Status === "N" ? "N" : "Y",
      services,
    });
    setMode("U");
  };

  return (
    <div className="Package">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={packageList}
                  name="ข้อมูลแพ็คเก็จ"
                  onPageInsert={onPageInsert}
                  onRowSelected={onRowSelected}
                  serviceCountByPack={serviceCountByPackage}
                  loading={isLoading}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name="ข้อมูลแพ็คเก็จ"
                  initialData={selectedPackage}
                  serviceOptions={serviceOptions}
                  setMode={setMode}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Package;
